import React, { useState } from 'react';
import { Box } from '@mui/material';
import { permissionObj } from '../../../../Helpers/permission';
import { MenuItem } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllDevicesZoneNull, AddFreeDevice } from '../../../../reduxToolkit/Devices/DevicesApi';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import CustomModal from "../../../../components/Modal/CustomModal";
import {CustomSelectAndChildren} from "../../../../components/CustomSelectAndChildren";
import routes from "../../../../Routes/routes";
import {PlusIconsOptions} from "../../../../components/buttons/IconButtons";
import ButtonSubAction from "../../../../components/buttons/ButtonSubAction";

/*
Author : Arman Ali
Module: Zone
github: https://github.com/Arman-Arzoo
*/

const AddDeviceModal = (props) => {
    const { t } = useTranslation();
    // use hook importer
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    // destructure from prop
    const { title, item} = props;

    //use Selector hook to get state for redux store
    const { getAllDevicesZoneNull } = useSelector((state) => state.DevicesSlice);

    //use Selector hook to get state for redux store
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    //use State hook for local state management
    const [freeDevice, setFreeDevice] = useState('');

    // This section is in charge of update the current zone to a device with zone null
    const handleAddFreeDevice = () => {
        const params = {
            id: freeDevice,
            zoneId: item?.id,
        };
        dispatch(AddFreeDevice(params)).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success === true) {
                    setFreeDevice('');
                    props.onAdded();
                    props.onHide();
                }
                {
                    success === true
                        ? toast.success(t('device_added_successfully_to_zone')).toUpperCase()
                        : toast.error(t('fail_adding_device_to_zone').toUpperCase());
                }
            },
        );
    };

    // useEffect lifeCyle for dispatch list of device with zone null
    useEffect(() => {
        dispatch(GetAllDevicesZoneNull());
    }, []);

    // return main page modal
    return (
        <CustomModal
            {...props}
            title={title}
            size='md'
            onHide={props.onHide}
            buttonConfirm={t('confirm').toUpperCase()}
            cancelButton={true}
            confirmButton={true}
            onConfirm={() => {
                handleAddFreeDevice();
            }}
            classNameBody="pt-2"
        >
            <Box className='col-sm-12 col-md-6 col-lg-12 col-xl-12'>
                <CustomSelectAndChildren
                    id="slt_adc_freeDevice"
                    name="freeDevice"
                    value={freeDevice}
                    keyName="freeDevice"
                    onChange={(e) => setFreeDevice(e.target.value)}
                    trans={
                        getAllDevicesZoneNull?.content?.length === 0
                            ? t('no_devices_available')
                            : t('select_one_available')
                    }
                    label="lbl_adc_freeDevice"
                    showNoSelectionOption={false}
                    disabled={getAllDevicesZoneNull?.content?.length === 0}

                >
                    {getAllDevicesZoneNull?.map((item, index) => {
                        return <MenuItem value={item.id}>{item.name}</MenuItem>;
                    })}
                </CustomSelectAndChildren>
            </Box>
            <Box className='col-sm-12 col-md-6 col-lg-12 col-xl-12 justify-content-center d-flex'>
                {(DEV || permission?.includes(permissionObj?.WEB_ZONE_CREATE_DEVICES)) && (
                    <ButtonSubAction
                        id='btn_adm_add_new_device'
                        name={'or_add_a_new_one'}
                        Icon={PlusIconsOptions}
                        className={'btn-icon-hover-black btn-icon-svg-black'}
                        splitName={false}
                        url={routes.devices.create}
                        state={{ zoneIdProps: item?.id, zoneNameProps: item?.name }}
                    />
                )}
            </Box>
        </CustomModal>
    );
};

export default AddDeviceModal;
